import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { CustomerMatchingDispatcher } from "./Variable";
import { CustomerSearchModel } from "../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";

export interface CustomerMatchingStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: CustomerSearchModel;
}

export class CustomerMatchingStoreStatic extends BaseStore<CustomerMatchingStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CustomerMatchingDispatcher, (actionData) =>
            this.onCustomerMatchingStoreResponse(actionData)
        );
    }

    public getLastResult(): CustomerMatchingStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): CustomerMatchingStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onCustomerMatchingStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
